import { z } from 'zod'
import { oc } from '@orpc/contract'
import { discoveredFacilitySchema } from './facility-discovery-search.contract'

// The caller's practice's remembered imaging centers (FavoriteStore). Coordinates
// are optional as a pair: with them each row carries a distance, without them none.
// Exported (not inlined into .input()) so the contract spec imports a plain zod
// schema — see facility-discovery-search.contract.spec.ts.
export const facilityDiscoveryFrequentInputSchema = z
  .object({
    lat: z.coerce.number().min(-90).max(90).optional(),
    lon: z.coerce.number().min(-180).max(180).optional(),
  })
  .refine((v) => (v.lat === undefined) === (v.lon === undefined), {
    message: 'lat and lon must be given together',
  })

export const frequentFacilitySchema = discoveredFacilitySchema.extend({ bookmarked: z.boolean() })

export const facilityDiscoveryFrequent = oc
  .route({ method: 'GET', path: '/v2/facility-discovery/frequent' })
  .input(facilityDiscoveryFrequentInputSchema)
  .output(z.object({ facilities: z.array(frequentFacilitySchema) }))
